function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "mapa-icon");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Welcome",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Desktop-HD",
  transform: "translate(-379.000000, -806.000000)",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "section__gasStation-price-list-item-empty",
  transform: "translate(327.000000, 780.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "mapa-icon",
  transform: "translate(52.000000, 26.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(35.443038, 45.189873)",
  fill: "#44C868"
}, /*#__PURE__*/React.createElement("path", {
  d: "M104.155771,77.9674988 L93.1560528,17.2742576 C93.0463947,16.6684508 92.6712054,16.1437104 92.13358,15.8443673 L64.4477832,0.422585843 C64.0884547,0.2221109 63.6856458,0.142413894 63.2899469,0.173087656 L68.3268357,65.2474732 L68.1581099,65.3230621 L101.291808,80.2099699 C101.561441,80.3307478 101.848029,80.3904521 102.133249,80.3904521 C102.584734,80.3904521 103.032118,80.2417391 103.399923,79.953351 C104.000992,79.4833851 104.291682,78.7187321 104.155771,77.9674988 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M34.1826969,15.1657103 L5.86711809,0.395472428 C5.52775228,0.21827668 5.15146915,0.145974241 4.78092872,0.170896673 C4.87910142,0.164871469 4.97782105,0.166121272 5.07572029,0.173087656 L0.0388315436,65.2474732 L33.3412556,80.2102437 C33.6100683,80.3307478 33.8969295,80.390726 34.1826969,80.390726 L34.1826969,80.390726 L34.1826969,15.1657103 L34.1826969,15.1657103 Z",
  id: "Path"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(0.000000, 45.189873)",
  fill: "#4CE166"
}, /*#__PURE__*/React.createElement("path", {
  d: "M40.8989132,0.173361528 C40.5032143,0.142687767 40.1004054,0.222384773 39.7410768,0.422585843 L12.0550066,15.8443673 C11.5173812,16.1437104 11.1421919,16.6681769 11.0325338,17.2742576 L0.0330888506,77.9674988 C-0.103095014,78.7184582 0.187868102,79.4831113 0.788663182,79.9536249 C1.15701592,80.242013 1.6041256,80.390726 2.0553372,80.390726 C2.34055762,80.390726 2.62741881,80.3312955 2.89677846,80.2102437 L35.8499921,65.4044024 L40.8989132,0.173361528 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M99.1131398,0.171992164 C98.840772,0.193080375 98.5714124,0.265656687 98.321742,0.396020174 L70.0061632,15.1659842 L70.0061632,80.3909998 C70.0061632,80.3909998 70.0061632,80.3909998 70.0061632,80.3909998 C70.292204,80.3909998 70.5793387,80.3312955 70.8478779,80.2105176 L104.150302,65.2477471 L99.1131398,0.171992164 Z",
  id: "Path"
})), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  fill: "#FFDB56",
  points: "7.53040133 80.6374438 5.3164557 93.0379747 38.0999752 75.4349998 38.8610783 65.4529292 38.9873418 63.7974684"
}), /*#__PURE__*/React.createElement("path", {
  d: "M38.9873418,71.7721519 L38.6884859,75.6425319 L5.48392964,93.2443325 L0.0331726053,123.385756 C-0.103494246,124.140993 0.188500794,124.910001 0.791426643,125.383194 C1.16108578,125.673225 1.60978116,125.822785 2.06259302,125.822785 C2.348825,125.822785 2.63670357,125.763016 2.90701853,125.641275 L35.9771034,110.751109 L38.9873418,71.7721519 L38.9873418,71.7721519 Z",
  id: "Path",
  fill: "#A8EEFC"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(38.101266, 52.278481)",
  fill: "#FFBB24"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  points: "31.6302782 16.2423028 1.15911353 11.8482486 0.266334412 23.4633645 31.6221001 71.4862017 31.6221001 54.0238017 12.911358 24.3109444 31.6302782 26.5688665"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  points: "87.218659 7.53859489 73.9605483 0.101720583 61.4093006 3.05931527 61.5663207 5.10362407 62.1862229 13.1681419"
})), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  fill: "#FFDB56",
  points: "101.898734 79.7468354 100.701557 64.1450913 100.701557 64.1450913 99.9950575 54.9367089 70 68.2371202 70 78.6556647 89.5930696 70.0488962"
}), /*#__PURE__*/React.createElement("path", {
  d: "M139.96746,122.999028 L137.229839,107.832697 L101.012658,65.5696203 L102.119304,79.9218637 L139.261309,124.936709 C139.826013,124.466184 140.098881,123.727293 139.96746,122.999028 Z",
  id: "Path",
  fill: "#FFBB24"
}), /*#__PURE__*/React.createElement("path", {
  d: "M70.442764,0 C54.5640371,0 41.6455696,12.9874371 41.6455696,28.9511964 C41.6455696,38.826147 46.3051157,49.4282265 55.4951792,60.4625039 C62.2449326,68.5670417 68.902914,73.7796021 69.1831607,73.9976306 C69.5540835,74.2862219 69.9984238,74.4303797 70.443038,74.4303797 C70.8873782,74.4303797 71.3319925,74.2862219 71.7029152,73.9976306 C71.982888,73.7796021 78.6411434,68.5670417 85.3908967,60.4625039 C94.5809603,49.4282265 99.2405063,38.8264226 99.2405063,28.9511964 C99.2405063,12.9874371 86.321491,0 70.442764,0 Z M81.1074784,28.9509207 C81.1074784,34.8721424 76.3326012,39.6726264 70.442764,39.6726264 C64.5529269,39.6726264 59.7780496,34.8724181 59.7780496,28.9509207 C59.7780496,23.0294234 64.5529269,18.229215 70.442764,18.229215 C76.3326012,18.229215 81.1074784,23.029699 81.1074784,28.9509207 Z",
  id: "Shape",
  fill: "#6F5AE2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M70.9861208,0 C69.7513588,0 68.5351424,0.0821396549 67.3417722,0.240354963 C81.2061009,2.07802302 91.9515403,14.2526083 91.9515403,28.9511964 C91.9515403,38.826147 87.3799108,49.4282265 78.3632456,60.4625039 C74.1044726,65.6742374 69.8860161,69.6872281 67.3417722,71.9479981 C68.7541958,73.2026951 69.6524488,73.9199011 69.7502837,73.9976306 C70.1142079,74.2862219 70.5501643,74.4303797 70.9863895,74.4303797 C71.422346,74.4303797 71.8585712,74.2862219 72.2224954,73.9976306 C72.4971856,73.7796021 79.0298128,68.5670417 85.6522116,60.4625039 C94.6688768,49.4282265 99.2405063,38.8264226 99.2405063,28.9511964 C99.2399688,12.9874371 86.5652474,0 70.9861208,0 Z",
  id: "Path",
  fill: "#5132FB"
}), /*#__PURE__*/React.createElement("path", {
  d: "M70.8458972,125.641917 L83.2911392,120.066023 L70,106.329114 L70,125.822785 C70,125.822785 70,125.822785 70.0002748,125.822785 C70.2874621,125.822785 70.5757487,125.763227 70.8458972,125.641917 Z",
  id: "Path",
  fill: "#FFDB56"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(35.443038, 59.367089)",
  fill: "#1EA4E9"
}, /*#__PURE__*/React.createElement("path", {
  d: "M93.2542443,2.77326543 C93.1444703,2.16432528 92.7688845,1.63687078 92.2306907,1.33597947 L90.0488983,0.115621549 L64.9111999,5.75272263 L64.9111999,5.75272263 L101.499613,48.4558899 L93.2542443,2.77326543 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M34.2187593,66.2161857 C34.2187593,66.2161857 34.2187593,66.2161857 34.2187593,66.2161857 L34.2187593,64.1493128 L2.73120995,16.0620354 L0.0383250871,50.9948841 L33.3759496,66.0350452 C33.6450464,66.1564479 33.9322108,66.2161857 34.2187593,66.2161857 Z",
  id: "Path"
}))))));

var SvgMapaIcon = function SvgMapaIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "141px",
    height: "127px",
    viewBox: "0 0 141 127",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMapaIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mapa-icon.a9c174e7.svg";
export { ForwardRef as ReactComponent };